import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GermplasmService } from '../germplasm/service/germplasm.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SubscriptionsManager } from '../util/subscriptions-manager';

@Component({
    selector: 'jhi-column-filter-name-types',
    template: `
		<form #f='ngForm'>
			<section class="filter-wrapper">
				<div class="keyword-wrapper">
					<input type="text" class="form-control" [formControl]="queryField" id="keyword" placeholder="{{ nameTypesPlaceholder | translate }}" autofocus/>
				</div>
				<ul class="filter-select">
					<li *ngFor="let result of results" class="filter-select-list" (click)="addNameType(result)">
						<label class="label-info">{{ 'column-filter.name.types.code' | translate }}</label> {{result.code}} - <label class="label-info">{{ 'column-filter.name.types.name' | translate }}</label> {{result.name}}</li>
				</ul>
			</section>
			<div *ngIf="this.filter.nameTypes.length === 0"><span>{{ 'column-filter.name.types.label' | translate}}</span></div>
			<br/>
			<div *ngFor="let nameType of filter.nameTypes">
				<div class="mb-3">
					<label for="{{nameType.code}}">{{nameType.name}}</label>
					<div class="input-group">
						<input type="text" class="form-control" [(ngModel)]="nameType.value" name="{{nameType.code}}">
                        <button class="btn btn-outline-info float-end fa fa-minus" (click)="deleteNameType(nameType)"></button>
					</div>
				</div>
			</div>
			<br/>
			<div class="footer text-center"><br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterNameTypesComponent implements OnInit, OnDestroy {

    queryField: FormControl = new FormControl();
    results: any[] = [];

    @Input() filter: any;

    @Output() onAdd = new EventEmitter();
    @Output() onDelete = new EventEmitter();
    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();
    nameTypesPlaceholder: string;

    subscriptionManager = new SubscriptionsManager();

    constructor(private germplasmService: GermplasmService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.queryField.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((query) => this.germplasmService.searchNameTypes(query))
            ).subscribe((result) => {
                if (result.status === 400) {
                    return;
                } else {
                    this.results = result.body;
                }
            });
        this.nameTypesPlaceholder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.name.types.placeholder';
    }

    addNameType(nameType) {
        // Reset query field value
        this.queryField.setValue('');
        // Do not add name type if it's already in the list
        if (!this.filter.nameTypes.some((e) => e.code === nameType.code)) {
            this.filter.nameTypes.push({ ...nameType, value: '' });
        }
        this.onAdd.emit(nameType);
    }

    deleteNameType(nameType) {
        this.filter.nameTypes = this.filter.nameTypes.filter((e) => e.code !== nameType.code);
        this.onDelete.emit(nameType);
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
